import { FEES_GET } from '../actions/types';

const initialState = {
  items: undefined,
  map: undefined,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FEES_GET._SUCCESS: {
      const { fees } = action.payload;
      state.items = fees;
      return state;
    }
    default:
      return state;
  }
};

export { reducer as fees };
